import { createApi, type RequestOptions } from '@romain130492/topchopsticks'
import { request } from './http'
import { env } from './env'
import {
  fixtureApplication, fixtureAttendees, fixtureEvents, fixtureProfile
} from './fixtures'
import { getToken, setToken } from './storage'

/**
 * VITE_DEV_MODE=true serves local fixtures instead of calling the backend —
 * the same switch the mini program has. Everything above this line is
 * identical in both modes, so a screen cannot behave differently just because
 * the data was faked.
 */
const devTransport = async <T,>(path: string, options: RequestOptions = {}): Promise<T> => {
  await new Promise((resolve) => setTimeout(resolve, 120))   // visible spinners
  const signedIn = Boolean(getToken())

  if (path === '/events') {
    const source = options.query?.source
    return fixtureEvents.filter((e) => !source || e.source === source) as unknown as T
  }
  if (path.startsWith('/events/') && path.endsWith('/attendees')) return fixtureAttendees as unknown as T
  if (path.startsWith('/events/')) {
    const id = path.split('/')[2]
    return (fixtureEvents.find((e) => e.id === id) || fixtureEvents[0]) as unknown as T
  }
  if (path === '/auth/sms/send') return { sent: true, expires_in: 300 } as unknown as T
  if (path === '/auth/sms/verify') {
    setToken('dev-token')
    return { token: 'dev-token', profile: fixtureProfile } as unknown as T
  }
  if (path === '/me') {
    if (!signedIn) throw Object.assign(new Error('Not signed in'), { status: 401 })
    return fixtureProfile as unknown as T
  }
  if (path === '/me/application') return (signedIn ? fixtureApplication : null) as unknown as T
  if (path === '/me/event-matches') return { matches: [] } as unknown as T

  console.warn('[tc][dev] no fixture for', path)
  return null as unknown as T
}

export const api = createApi(env.devMode ? devTransport : request)
